import React from "react";

import { Modal, Select, Input, message } from "antd";
const { Option } = Select;

class IotDeviceEditor extends React.Component{

    constructor( props ){
        super(props);

        let iotDevice = props.iotDevice || {};

        this.state = {
            _id: "" || iotDevice._id,
            deviceName: "" || iotDevice.deviceName,
            deviceType: "" || iotDevice.deviceType,
            enterpriseId: "" || iotDevice.enterpriseId
        };
    }

    render(){

        return (
            <Modal 
                onOk={ this.onConfirm }
                onCancel={ this.props.onCancel } 
                visible={true}>

                <h2>Device Type:</h2>
                <Select 
                    defaultValue={this.state.deviceType} 
                    style={{ width: 120 }} 
                    onChange={ (e) => this.onChangeInput( "deviceType", e ) }>
                    <Option value="VM">VM</Option>
                    <Option value="LOCKER">LOCKER</Option>
                    <Option value="ZONE_STORE">ZONE_STORE</Option>
                </Select>

                <h2>Device Name:</h2>
                <Input 
                    defaultValue={this.state.deviceName} 
                    onChange={ (e) => this.onChangeInput( "deviceName", e.target.value ) }/>


                <h2>Enterprise Id:</h2>
                <Input 
                    defaultValue={this.state.enterpriseId} 
                    onChange={ (e) => this.onChangeInput( "enterpriseId", e.target.value ) }/>

            </Modal>
        )

    }

    onChangeInput = ( fieldName, value ) => {

        this.setState({
            [fieldName]: value
        });

    }

    onConfirm = () => {

        let { 
            _id,
            deviceType,
            deviceName, 
            enterpriseId
        } = this.state;

        message.destroy();
        
        if( !deviceName || !deviceType ){
            return message.error("Device Name & Type are required");
        }

        if( deviceName.split(" ").length > 1 ){
            return message.error("White space is not allowed in device name");
        }

        this.props.onConfirm({
            _id,
            deviceType,
            deviceName, 
            enterpriseId
        });

    }

}

export default IotDeviceEditor;


// WEBPACK FOOTER //
// ./src/components/iot-devices/iot-device-editor.js